import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
// IMPORTANTE: el importe cobrado lo define el checkout externo. Debe configurarse en 23,99 € (EUR) para coincidir con la landing.
export const CHECKOUT_URL = 'https://megapack-salud-plena.impultienda.ar/checkout';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  variant?: 'solid' | 'light';
  className?: string;
  href?: string;
};
export function CtaButton({
  children,
  size = 'lg',
  variant = 'solid',
  className = '',
  href = CHECKOUT_URL
}: CtaButtonProps) {
  const reduceMotion = useReducedMotion();
  const sizeClasses = size === 'lg' ? 'px-6 py-4 text-[15px] sm:px-8 sm:text-lg' : 'px-5 py-3 text-sm sm:text-base';
  const variantClasses = variant === 'solid' ? 'bg-mint-600 text-white hover:bg-mint-700 focus-visible:outline-mint-700' : 'bg-white text-mint-800 ring-1 ring-inset ring-mint-300 hover:bg-mint-50 focus-visible:outline-mint-600';
  return <motion.a href={href} whileTap={reduceMotion ? undefined : {
    scale: 0.97
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} className={`group inline-flex items-center justify-center gap-2.5 rounded-full font-semibold shadow-soft transition-[background-color,box-shadow] duration-150 ease-out hover:shadow-lift focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${sizeClasses} ${variantClasses} ${className}`} data-id="element-76" data-mp="35xxs8pp8wnsr">
      <span className="whitespace-nowrap" data-id="element-77" data-mp="3ou7brsix26k5">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-78" data-mp="3swap6mp5bl82" />
    </motion.a>;
}